import { Fragment, type ReactNode, type FC } from 'react';
import Zoom from 'react-medium-image-zoom';
import useModal from '../Modal/hooks/useModal';

interface ImageZoomProps {
  width: number;
  children: ReactNode;
}

export const IMAGE_ZOOMABLE_WIDTH_THRESHOLD = 500;

const ImageZoom: FC<ImageZoomProps> = ({ width, children }) => {
  const { isOpen } = useModal();
  const ZoomContainer = !isOpen() && width >= IMAGE_ZOOMABLE_WIDTH_THRESHOLD ? Zoom : Fragment;
  return <ZoomContainer>{children}</ZoomContainer>;
};

export default ImageZoom;
